module.exports = __webpack_public_path__ + "img/dashboard-faq.cb5bf0c0.svg";